import React from 'react'
import { useBookings } from 'api'
import { BookingsList } from './BookingsList'
import { Link } from 'components'
import { WbSpinner } from '@workbench/react/dist'
import classes from './BookingsPage.module.scss'

import { useTranslation } from 'react-i18next'

export const BookingsPage: React.FunctionComponent = () => {
  const { data: bookings, error } = useBookings()
  const { t } = useTranslation()
  return (
    <>
      <h1 id="bookings-overview-title-e2e">
        {t('pages.bookings.bookingsPage.bookingsPage.heading')}
      </h1>
      {error && <p>{t('pages.bookings.bookingsPage.bookingsPage.error')}</p>}

      {!bookings && !error && <WbSpinner className={classes.spinner} />}

      {bookings && bookings.length === 0 && (
        <p>
          {t('pages.bookings.bookingsPage.bookingsPage.emptyBookingInfo')}{' '}
          <Link to="/bookings/new" variant="inline">
            {t(
              'pages.bookings.bookingsPage.bookingsPage.createFirstBookingRequest'
            )}
          </Link>
        </p>
      )}

      {bookings && bookings.length > 0 && (
        <>
          <BookingsList bookings={bookings} />
          <Link to="/bookings/new">
            {t(
              'pages.bookings.bookingsPage.bookingsPage.createNewBookingRequest'
            )}
          </Link>
        </>
      )}
    </>
  )
}
